<template>
   <div class="box_flow">
    <div class="top_box">
      <span>直播时间 {{ tableList.startTime }}</span>
      <span>时长 {{ tableList.liveTime }}</span>
    </div>
    <div class="border"></div>
    <div class="bottom_box">
      <div class="live">
        <div class="image" @click="to(tableList.liveLink)">
          <img :src="tableList.poster" alt="">
          <div class="index">{{ tableList.index }}</div>
        </div>
        <div class="text">
          <div class="name" @click="to(tableList.liveLink)">{{ tableList.title }}</div>
          <div class="user" @click="to(tableList.avatarLink)">
            <img :src="tableList.avatar" alt="" class="anchor">
            <div class="avatarName">
              <div class="txt_1">{{ tableList.avatarName }}</div>
              <div class="txt_2">{{ tableList.fans }} 粉丝</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="box1">
        <span>销售额</span>
        <p>{{ tableList.sales }}</p>
      </div>
      <div class="box2">
        <div class="avg">
          <div class="text_top" v-if="flag">
            <div class="deg"></div>
            <span>平均每分钟进入直播间的人数</span>
          </div>
          <span>分钟流量</span> <van-icon name="warning-o" class="warning"  @click="liveCount"/>
        </div>
         <p>{{ tableList.avgViews }}</p>
      </div>
      <div class="box3">
        <span>直播总流量(UV)</span>
        <p>{{ tableList.views }}</p>
      </div>
    </div>
   </div>
</template>

<script>
export default {
  props: { info: Object ,index:Number},
  data() {
    return {
      flag:false
    }
  },
  computed: {
    isVip:(_this = this) => _this.$store.state.userLevel && _this.$store.state.userLevel < 1000,
    tableList() {
        return {
          ...this.info,
          index: this.index,
          poster:this.info?.liveStream?.poster,//直播封面
          title:this.info?.liveStream?.title,//直播标题
          startTime:this.info?.liveStream?.startTime ? moment(this.info?.liveStream?.startTime * 1000).format('MM-DD HH:mm') : '-',
          liveTime:this.info?.liveStream?.duration ? this.Time(this.info?.liveStream?.duration) : '-',
          avatar:this.info?.anchor?.avatar,//达人头像
          avatarName: this.info?.anchor?.name || '-',//达人姓名
          fans:this.info?.anchor?.fans ? this.$retainWan(this.info.anchor.fans) : '-',//达人粉丝数
          views:this.info?.views?  this.$retainWan(this.info.views) : '-',//直播总流量
          avgViews:this.info?.avgViews?  this.$retainWan(this.info.avgViews) : '-',//分钟流量
          sales:+this.info?.sales? '¥' + this.$retainWan(+this.info.sales) : '未卖货',//销售额
          avatarLink: `/anchor/${this.info?.anchor?.id}?banner=2`,//个人主页链接
          liveLink: `/live/${this.info?.anchor?.id}/${this.info?.liveStreamId}`//直播详情链接
        }
    }
  },
  methods: {
    liveCount() {
      if(this.flag === true) {
        this.flag = false
      } else {
        this.flag = true
        setTimeout(() => {
          this.flag = false
        }, 1500);
      }
      
    },
    to(url) {
      this.$router.push({path:url})
    },
    Time(tiem) {
      const HH =Math.floor(tiem / 3600)
      const MM = Math.floor((tiem % 3600) / 60)
      // const SS = Math.floor(((tiem % 3600) / 60) % 60)
      return `${HH}时${MM}分`
    },
  }
};
</script>
<style lang="less" scoped>
.text {
  padding: 5px 0;
}
.box_flow {
  font-family: number-bold,sans-serif;
  height: 203px;
  width: 100vw;
  background-color: #fff;
  margin-bottom: 12px;
  .top_box {
    height: 42px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color:#8E9AAE;
    span {
      margin-right: 15px;
    }
  }
  .border {
    height: 1px;
    background-color:#F2F2F2;
  }
  .bottom_box {
    padding: 15px;
    .live {
      display: flex;
     
      .image {
                    position: relative;
                    width: 60px;
                    height: 80px;
                    border-radius: 4px;
                    overflow: hidden;
                    margin-right: 8px;
                    background-color: #000;
                    img {
                        width: 100%;
                    }
                    .index {
                    background-color: rgba(0, 0, 0,.3);
                    border-radius: 0 3px 3px 0;
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: 8px;
                    z-index: 1;
                    color: #fff;
                    font-size: 10px;
                    font-weight: 500;
                    width: 12px;
                    height: 12px;
                }
                }
                .name {
                  width: 251px;
                  font-size: 14px;
                  font-weight: 500;
                  color:#141B27;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  margin-bottom: 10px;
                  line-height: 18px;
                }
                .user {
                  display: flex;
                  .anchor {
                    width: 42px;
                    height: 42px;
                    border-radius: 50%;
                    margin-right: 6px;
                  }
                .avatarName {
                  height:42px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  .txt_1 {
                    width: 181px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: 14px;
                    color: #252E39;
                  }
                  .txt_2 {
                    font-size: 14px;
                    color: #8E9AAE;
                  }
                }
                }
    }
  }
  .bottom {
    display: flex;
    height: 36px;
    .box1 {
      flex:1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      span {
        color: #A1A4A9;
        font-size: 12px;
      }
      p {
        color: #141B27;
        font-weight: 500;
        font-size: 16px;
      }
    }
    .box2 {
      flex:1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      p {
        color: #141B27;
        font-weight: 500;
        font-size: 16px;
        }
      .avg {
        display: flex;
        align-items: center;
        position: relative;
        .text_top {
        display: flex;
        align-items: center;
        justify-content: center;
        right: 8px;
        top: -35px;
        width: 180px;
        height: 30px;
        border-radius: 5px;
        background-color: rgba(0, 0, 0,1);
        position: absolute;
        transform: translateX(50%);
        span {
          font-size: 12px;
          color: #fff;
        }
        .deg {
          background-color: rgba(0, 0, 0,1);
          width: 10px;
          height: 10px;
          position: absolute;
          transform: rotate(45deg) translateX(-50%);
          bottom: -6px;
          left:50%;
        }
        }
        span {
        color: #A1A4A9;
        font-size: 12px;
      }
      .warning {
          color: #A1A4A9;
          font-size: 14px;
          margin-left: 2px;
        }
      }
    }
    .box3 {
      flex:1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      span {
        color: #A1A4A9;
        font-size: 12px;
      }
      p {
        color:#FF5000;
        font-weight: 500;
        font-size: 16px;
      }
    }
  }
}
</style>